// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"styles_arrowIcon__1_Cc6"};